import modal from 'ngtemplate-loader!./template.tpl.html';
import "./styles";

export const moduleName = 'rezflow.cancelBooking'
export const name = 'cancel';

const ELEMENT = new WeakMap();
const DOCUMENT = new WeakMap();
const API = new WeakMap();

export default (MODULE) => {

  class Cancel {

    /* @ngInject */
    constructor($document, $element, $timeout, $rootScope, BookingAPI) {
      const vm = this;
      this.$timeout = $timeout;
      API.set(this, BookingAPI);
      ELEMENT.set(this, $element);
      DOCUMENT.set(this, $document);
      this.user = $rootScope.user;
      this.reason = this.cancellations.find(template => template.default);
    }

    get company(){
      return this.user.activeCompany();
    }

    get cancellations(){
      return this.company.cancellations;
    }

    cancelOne() {
      this.booking.cancel(this.reason._id).then(res => {
        this.active = false;
        this.then();
      });
    }

    cancelDay(){
      const api = API.get(this).req();
      api.cancelAll({ 
        day: this.day.format('MM-DD-YY'), 
        reason: this.reason._id 
      }).$promise.then(res => {
        this.active = false;
        window.location.reload();
        this.then();
      });
    }

    submit() {
      if(this.day) {
        this.cancelDay();
      } else {
        this.cancelOne();
      }
    }

    style(){
      return this.active ? { 'display': 'block' } : undefined;
    }

    $onDestroy() {
      const $document = DOCUMENT.get(this);
    }

    $onInit() {}

  }

  angular.module(MODULE)
    .component(name, {
      bindings: {
        booking: '<?',
        day: '=?',
        then: '&'
      },
      transclude: true,
      templateUrl: modal,
      controller: Cancel
    });

  return name;

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/cancel/popover.js